export const ApiName = {
  generateGwtToken: "authenticateWeb",
  // generateGwtToken: "generateToken",
  checkOperator: "user/checkOperator",
  signupweb: "user/signupWeb",
  verifyOtp: "user/verifyOtpWeb",
  subscribe: "user/subscribeWeb",
  ffSubscribe: "user/ffSubscribe",
  login: "user/loginUser",
  utm_list: "user/utmList",
  unSubscribe: "user/unsubscribeWeb",
  checkUser: "user/CheckUser",
  getFLow: "user/getFlow",
  awarenessFLow: "user/awarenessFlow",
  changePackageWeb: "user/change/package",
  package_list: "user/packages",
  validateHe: "validateHe",
  validateSignature: "validate/signature",
  validateSubscribe: "validate/subscribe",
  viewVideo: "viewVideo",
  foryou: "mostViewed/",

  // OTM
  agoraGetSubscriberList: "tutorOTM/agora/getSubscriberList",
  agoraStartRecording: "tutorOTM/agora/startRecording",
  tutorLeaveOTM: "tutorOTM/agora/tutor/leave",
  tutorOTMProfile: "tutorOTM/agora/tutor/profile",
  agoraDecStringOTM: "tutorOTM/agora/decString",
  OTMAgoraSessionEnding: "tutorOTM/agora/sessionEnding",

  // Video

  rightsAllowVideo: "agora-video/rightsAllow",
  rightsRevokeVideo: "agora-video/rightsRevoke",
  requestListingVideo: "agora-video/requestListing",
  decStringVideo: "agora-video/decString",
  sessionDetailVideo: "agora-video/sessionDetail",
  endSessionVideo:"agora-video/endSession",
  rejectRequestvideo:"agora-video/rejectRequest",
  sessionEndedvideo:"agora-video/sessionEnded",
  liveCommentsVideo:"agora-video/live-comments",

  //Audio

  rightsAllowPodcast: "agora-podcast/rightsAllow",
  rightsRevokePodcast: "agora-podcast/rightsRevoke",
  requestListingPodcast: "agora-podcast/requestListing",
  decStringPodcast: "agora-podcast/decString",
  sessionDetailPodcast: "agora-podcast/sessionDetail",
  agoraEndSessionPodcast:"agora-podcast/endSession",
  rejectRequestPodcast:"agora-podcast/rejectRequest",
  sessionEndedPodcast:"agora-podcast/sessionEnded",
  liveCommentsPodcast:"agora-podcast/live-comments",
  getParticipants:"agora-podcast/getParticipants"


};
